export const sliderItems = [
  {
    id: 1,
    image:
      "https://res.cloudinary.com/dq0ljafid/image/upload/v1683080824/yxkcmzf5lrtiecq1pwrl.png",
    title: "FLASH SALE",
    desc: "SHOP IN STYLE! GET FLAT 30% OFF FOR LATEST ARRIVALS.",
    bg: "f7f7ff",
  },
  {
    id: 2,
    image:
      "https://res.cloudinary.com/dgiksl9k7/image/upload/v1683348738/xara-ecommerce-app/slider%20images/_removal.ai__9b229430-f1af-49cc-9fce-97967db1fe81_XZ697J2-removebg-preview_flpjb6.png",
    title: "WOMEN'S COLLECTION",
    desc: "GET FLAT 40% ON SELECT ITEMS",
    bg: "fcf1ed",
  },
  {
    id: 3,
    image:
      "https://res.cloudinary.com/dgiksl9k7/image/upload/v1683348416/xara-ecommerce-app/slider%20images/_removal.ai__9b9211f0-00ac-42b1-bc4f-f00e0d9ba277_GACOQS-removebg-preview_abxzcj.png",
    title: "VINTAGE VIBE",
    desc: "SHOP IN STYLE! GET FLAT 40% OFF ON SELECT ITEMS",
    bg: "fbf0f4",
  },
]

export const categories = [
  {
    id: 1,
    img: "https://res.cloudinary.com/dgiksl9k7/image/upload/v1683248676/xara-ecommerce-app/categories/mens-black-suit-styles-business-professional-ideas_ymnzhw.jpg",
    title: "MEN IN STYLE!",
    category: "men"
  },
  {
    id: 2,
    img: "https://res.cloudinary.com/dgiksl9k7/image/upload/v1683248676/xara-ecommerce-app/categories/d5e34a597407651fe900f9f80d7d6fad_gahknf.jpg",
    title: "LADY LOVE!",
    category: "women"
  },
  {
    id: 3,
    img: "https://res.cloudinary.com/dgiksl9k7/image/upload/v1683248676/xara-ecommerce-app/categories/leatherjacketsmain1_g3qggu.jpg",
    title: "LIGHT JACKETS",
    category: "jackets"
  },
]

export const popularProducts = [
    {
      id: 1,
      img: "https://res.cloudinary.com/dgiksl9k7/image/upload/v1683351711/xara-ecommerce-app/products/4467449812_1_1_1_ng6zwr.jpg",
    },
    {
      id: 2,
      img: "https://res.cloudinary.com/dgiksl9k7/image/upload/v1683351711/xara-ecommerce-app/products/3736044403_1_1_1_nnhhqi.jpg",
    },
    {
      id: 3,
      img: "https://res.cloudinary.com/dgiksl9k7/image/upload/v1683351710/xara-ecommerce-app/products/4467408400_1_1_1_i7la2j.jpg",
    },
    {
      id: 4,
      img: "https://res.cloudinary.com/dgiksl9k7/image/upload/v1683351710/xara-ecommerce-app/products/3046240800_1_1_1_wtqjou.jpg",
    },
    {
      id: 5,
      img: "https://res.cloudinary.com/dgiksl9k7/image/upload/v1683351758/xara-ecommerce-app/products/1856083330_6_1_1_v3ieju.jpg",
    },
    {
      id: 6,
      img: "https://res.cloudinary.com/dgiksl9k7/image/upload/v1683351711/xara-ecommerce-app/products/3918505711_1_1_1_zp6lh4.jpg",
    },
    {
      id: 7,
      img: "https://res.cloudinary.com/dgiksl9k7/image/upload/v1683351710/xara-ecommerce-app/products/2211120070_1_1_1_ixhss6.jpg",
    },
    {
      id: 8,
      img: "https://res.cloudinary.com/dgiksl9k7/image/upload/v1683351710/xara-ecommerce-app/products/3920433705_6_1_1_mxbaio.jpg",
    },
    {
      id: 9,
      img: "https://res.cloudinary.com/dgiksl9k7/image/upload/v1683351710/xara-ecommerce-app/products/0108042427_1_1_1_zsfxaq.jpg",
    },
    {
      id: 10,
      img: "https://res.cloudinary.com/dgiksl9k7/image/upload/v1683351710/xara-ecommerce-app/products/8281886800_2_1_1_wrfqzw.jpg",
    },
    {
      id: 11,
      img: "https://res.cloudinary.com/dgiksl9k7/image/upload/v1683351710/xara-ecommerce-app/products/6135110400_6_1_1_g7nett.jpg",
    },
    {
      id: 12,
      img: "https://res.cloudinary.com/dgiksl9k7/image/upload/v1683351710/xara-ecommerce-app/products/3046441800_1_1_1_m15rkx.jpg",
    },
    {
      id: 13,
      img: "https://res.cloudinary.com/dgiksl9k7/image/upload/v1683351710/xara-ecommerce-app/products/2761240800_1_1_1_zuqoek.jpg",
    },
    {
      id: 14,
      img: "https://res.cloudinary.com/dgiksl9k7/image/upload/v1683351710/xara-ecommerce-app/products/4341826822_1_1_1_tno2iy.jpg",
    },
    {
      id: 15,
      img: "https://res.cloudinary.com/dgiksl9k7/image/upload/v1683351711/xara-ecommerce-app/products/4025227712_1_1_1_hg4v7m.jpg",
    },
  ]
  